import { render, staticRenderFns } from "./CBookSubheader.vue?vue&type=template&id=5a3f63c7&"
import script from "./CBookSubheader.vue?vue&type=script&lang=js&"
export * from "./CBookSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports